module.exports = __webpack_public_path__ + "static/media/keno.ecd680f8.png";